import { FC } from 'react'

export const PrivacyPage: FC = () => {
  return (
    <h1>Privacy page</h1>
  )
}
